import React, { useState } from "react";
import { HashRouter as Router, Route, Routes } from "react-router-dom";
import Cookies from "universal-cookie";

import "./App.css";
import "../src/css/sb-admin-2.css";

import Login from "./components/Login";
import Home from "./components/Home";
import Sidebar from "./components/Sidebar";
import Fondo from "./components/fondo";

import NTC from "./components/Formato1/NTC";
import InfoNormas from "./components/Administracion/InfoNormas";
import InfoPreguntas from "./components/Administracion/InfoPreguntas";
import InfoSecciones from "./components/Administracion/InfoSecciones";
import InfoNormasResultados from "./components/InfoNormasResultados";
import ConsultarResultados from "./components/Resultados/ConsultarResultados";

const cookie = new Cookies();

function App() {
  const [autenticado, setAutenticado] = useState(() =>
    Boolean(cookie.get("nitNumber")),
  );

  const handleLoginSuccess = () => {
    setAutenticado(Boolean(cookie.get("nitNumber")));
  };

  const handleLogout = () => {
    setAutenticado(false);
  };

  return (
    <Router>
      {autenticado && <Sidebar onLogout={handleLogout} />}

      <Routes>
        <Route
          path="/"
          element={
            autenticado ? (
              <Home />
            ) : (
              <Login onLoginSuccess={handleLoginSuccess} />
            )
          }
        />

        <Route path="/Home" element={<Home />} />
        <Route path="/fondo" element={<Fondo />} />

        <Route path="/InfoNormas" element={<InfoNormas />} />
        <Route path="/InfoPreguntas" element={<InfoPreguntas />} />
        <Route path="/InfoSecciones" element={<InfoSecciones />} />

        <Route path="/NTC/:id" element={<NTC />} />

        <Route path="/Resultados" element={<InfoNormasResultados />} />

        <Route path="/Consultar" element={<ConsultarResultados />} />
      </Routes>
    </Router>
  );
}

export default App;
